import React from "react";
import { FilterChip } from "../ui/FilterChip";

export default function OrdersStatusTabs({ tabs, active, onChange }) {
  return (
    <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1">
      {tabs.map((tab) => (
        <FilterChip
          key={tab.value}
          label={tab.label}
          count={tab.count}
          active={active === tab.value}
          onClick={() => onChange(tab.value)}
        />
      ))}
    </div>
  );
}
